// Business profiles created in this session. A brand-new profile has no billing customer yet, so
// the billing store registers it before reading its status (a status read first would be a 404).
const newBusinessProfileIds = new Set();

const keyOf = (id) => (id == null ? null : String(id));

export const markNewBusinessProfile = (id) => {
  const key = keyOf(id);
  if (key) newBusinessProfileIds.add(key);
};

// True once for a profile that was just created; later calls answer false.
export const consumeNewBusinessProfile = (id) => {
  const key = keyOf(id);
  return key ? newBusinessProfileIds.delete(key) : false;
};
